<div class="container">
    <div class="card flat">
        <div class="card-body">
            <div class="card-header">
                <h5 class="card-title">Promote Your Book</h5>
                <a (click)="goPromotions()" class="see-all-promotions">See All <img src="../../../assets/img/home/widgets/icon-arrow-right.png" alt="See All"></a>
            </div>
            <div class="row">
                <div class="col-3">
                    <a (click)="goFreebooksy()">
                        <div class="subcard">
                            <div class="subcard-header">
                                <div class="subcard-header-image" [style]="'background-image: url(../../../assets/img/home/widgets/update-jun-24/freebooksy.svg)'"></div>
                            </div>
                            <div class="subcard-title">
                                <img src="../../../assets/img/home/widgets/update-jun-24/freebooksy-icon.png" alt="">
                                <span>Freebooksy</span>
                            </div>
                            <div class="subcard-body">
                                <div class="subcard-body-container">
                                    <p class="subcard-body-container-text">Boost free downloads!</p>
                                    <a class="button-action button-primary" (click)="goFreebooksy()">Run a Promo</a>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-3">
                    <a (click)="goBargainBooksy()">
                        <div class="subcard">
                            <div class="subcard-header">
                                <div class="subcard-header-image bargain-booksy" [style]="'background-image: url(../../../assets/img/home/widgets/update-jun-24/bargainbooksy.svg)'"></div>
                            </div>
                            <div class="subcard-title">
                                <img src="../../../assets/img/home/widgets/update-jun-24/bargainbooksy-icon.png" alt="">
                                <span>Bargain Booksy</span>
                            </div>
                            <div class="subcard-body">
                                <div class="subcard-body-container">
                                    <p class="subcard-body-container-text">Drive sales of titles priced $0.99-$5.00!</p>
                                    <a class="button-action button-primary" (click)="goBargainBooksy()">Run a Promo</a>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-3">
                    <a (click)="goRedFeatherRomance()">
                        <div class="subcard">
                            <div class="subcard-header">
                                <div class="subcard-header-image bg-purple" [style]="'background-image: url(../../../assets/img/home/widgets/update-jun-24/red-feather-romance.svg)'"></div>
                            </div>
                            <div class="subcard-title">
                                <img src="../../../assets/img/home/widgets/update-jun-24/red-feather-romance-icon.png" alt="">
                                <span>Red Feather Romance</span>
                            </div>
                            <div class="subcard-body">
                                <div class="subcard-body-container">
                                    <p class="subcard-body-container-text">Reach avid Romance fans!</p>
                                    <a class="button-action button-primary" (click)="goRedFeatherRomance()">Run a Promo</a>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-3">
                    <a (click)="goAudioThicket()">
                        <div class="subcard">
                            <div class="subcard-header">
                                <div class="subcard-header-image audio-thicket" [style]="'background-image: url(../../../assets/img/home/widgets/update-jun-24/audio-thicket.svg)'"></div>
                            </div>
                            <div class="subcard-title">
                                <img src="../../../assets/img/home/widgets/update-jun-24/audio-thicket-icon.png" alt="">
                                <span>Audio Thicket</span>
                            </div>
                            <div class="subcard-body">
                                <div class="subcard-body-container">
                                    <p class="subcard-body-container-text">Grow your Audible audience!</p>
                                    <a class="button-action button-primary" (click)="goAudioThicket()">Run a Promo</a>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
